import clsx from "clsx";
import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface JobCellPropsHook {
  searchWords: string[];
  classNames: {
    title: string;
    id: string;
  };
}

export default function useJobCellProps(archived: string): JobCellPropsHook {
  const [query] = useQuery("payments");
  const searchWords = useSearchWords(query);

  const classNames = {
    title: clsx("text-14-22-em", archived === "archived" && "text-red-200"),
    id: clsx("text-12-18", archived === "archived" && "text-red-200"),
  };

  return {
    searchWords,
    classNames,
  };
}
